export const ApckWizardPane = {
    props: {
        title: {
            type: String,
            required: true,
        },
    },
    data: function() {
        return {
            error: [],
            complete: false,
            selected: false,
            disabled: true, // All panes are disabled by default.
        };
    },
    template: `
        <div v-show="selected" class="wizard-pane-container">
            <div v-if="error">
                <!--
                <p class="danger">
                    <span class="title">Errors:</span>
                    <span ng-repeat="_error in error">
                        {{_error}}
                    <span>
                </p>
                -->
            </div>
            <div class="wizard-pane" :class="[selected ? 'active' : '']">
                <slot />
            </div>
        </div>
    `
};


export const ApckWizard = {
    props: {
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            tabs: [],
            activePane: null,
            activePaneIndex: null
        };
    },
    created: function() {
    },
    computed: {
        lastStep() {
            return this.activePaneIndex === this.tabs.length - 1;
        }
    },
    methods: {
        select(selectedPane) {
            if (this.disabled) return;
            if (!selectedPane.disabled) {
                this.tabs.forEach((pane, index) => {
                    pane.selected = false;
                    if (selectedPane === pane) {
                        this.activePaneIndex = index;
                    }
                });
                selectedPane.selected = true;
                this.activePane = selectedPane;
            }
        },
        addPane(pane) {
            if (this.tabs.length === 0) {
                pane.disabled = false;
                this.activePaneIndex = 0;
                this.select(pane);
            }
            this.tabs.push(pane);
        },
        nextPane() {
            if (this.disabled) return;
            this.$emit("validate-step", this.activePaneIndex, (error, res) => {
                if (!error && res) {
                    this.activePane.complete = true;
                    this.activePane.error = null;
                    if (this.activePaneIndex < this.tabs.length - 1) {
                        const nextIndex = this.activePaneIndex + 1;
                        const nextPane = this.tabs[nextIndex];
                        nextPane.disabled = false;
                        this.selectIndex(nextIndex);
                    }
                } else {
                    this.activePane.error = error;
                }
            });
        },
        prevPane() {
            if (this.activePaneIndex > 0) {
                const prevIndex = this.activePaneIndex - 1;
                this.selectIndex(prevIndex);
            }
        },
        selectIndex(index) {
            if (index >= 0 && index < this.tabs.length) {
                this.select(this.tabs[index]);
            }
        },
        complete() {
            this.$emit("complete");
        }
    },
    mounted: function() {
        // console.log(this.$children);
        this.$children.forEach((pane, index) => {
            // console.log(pane);
            // console.log(pane.title);
            this.addPane(pane);
        });
    },
    template: `
        <!--
        <div class="wizard-panel">
            <ul class="steps">
                <li ng-repeat="pane in wizardPanel.tabs" ng-class="{active: pane.wizardPane.selected, disabled: pane.wizardPane.disabled, complete: pane.wizardPane.complete}">
                    <a href="javascript:;" ng-click="wizardPanel.select(pane)">{{$index + 1}}</a>
                </li>
            </ul>
            <h2>{{wizardPanel.activePane.wizardPane.title}}</h2>
            <div class="wizard-content">
                <slot />
            </div>
            <div class="pull-right">
                <button ng-if="wizardPanel.activePaneIndex > 0" class="btn" ng-click="wizardPanel.prevPane()">
                    Prev
                </button>
                <button ng-if="!wizardPanel.activePaneIndex" class="btn disabled">
                    Prev
                </button>
                <button ng-if="!wizardPanel.lastStep()" class="btn" ng-click="wizardPanel.nextPane()">
                    Next
                </button>
                <button ng-if="wizardPanel.lastStep()" class="btn btn-success" ng-click="wizardPanel.complete()">
                    Finish
                </button>
            </div>
            <div class="clear"></div>
        </div>
        -->
        <div class="wizard-panel">
            <ul class="steps">
                <li
                    v-for="(pane, index) in tabs"
                    :key="index"
                    :class="[activePaneIndex === index ? 'active' : '' , (pane.disabled || disabled) ? 'disabled' : '']"
                >
                    <a href="javascript:;" v-on:click="select(pane, index)">
                        {{ pane.title }}
                    </a>
                </li>
            </ul>
            <div class="wizard-content">
                <slot></slot>
            </div>
            <div class="pull-right">
                <button v-on:click="prevPane" v-if="activePaneIndex > 0" :class="['btn', 'btn-primary', disabled ? 'btn-disabled' : '']">
                    Prev
                </button>
                <button v-on:click="nextPane" v-if="!lastStep" :class="['btn', 'btn-primary', disabled ? 'btn-disabled' : '']">
                    Next
                </button>
                <button v-on:click="complete" v-if="lastStep" :class="['btn', 'btn-positive', disabled ? 'btn-disabled' : '']">
                    Complete
                </button>
            </div>
            <div class="clear"></div>
      </div>
    `

};
/*
<template>
  <div class="wizard-panel">
    <div class="tab-content">
      <div class="tab-pane" v-for="(tab, index) in tabs" :key="index" :class="{ active: activePaneIndex === index }">
        <slot :name="tab.title"></slot>
      </div>
    </div>
    <div class="wizard-footer">
      <button v-if="activePaneIndex > 0" @click="prevPane()">Prev</button>
      <button v-if="!lastStep()" @click="nextPane()">Next</button>
      <button v-if="lastStep()" @click="complete()">Complete</button>
    </div>
  </div>
</template>
*/

/*
export default {
  name: "WizardPanel",
  data() {
    return {
      tabs: [],
      activePane: null,
      activePaneIndex: null
    };
  },
  computed: {
    lastStep() {
      return this.activePaneIndex === this.tabs.length - 1;
    }
  },
  methods: {
    select(selectedPane) {
      if (!selectedPane.disabled) {
        this.tabs.forEach((pane, index) => {
          pane.selected = false;
          if (selectedPane === pane) {
            this.activePaneIndex = index;
          }
        });
        selectedPane.selected = true;
        this.activePane = selectedPane;
      }
    },
    addPane(pane) {
      if (this.tabs.length === 0) {
        pane.disabled = false;
        this.activePaneIndex = 0;
        this.select(pane);
      }
      this.tabs.push(pane);
    },
    nextPane() {
      this.$emit("validate-step", this.activePaneIndex, (error, res) => {
        if (!error && res) {
          this.activePane.complete = true;
          this.activePane.error = null;
          if (this.activePaneIndex < this.tabs.length - 1) {
            const nextIndex = this.activePaneIndex + 1;
            const nextPane = this.tabs[nextIndex];
            nextPane.disabled = false;
            this.selectIndex(nextIndex);
          }
        } else {
          this.activePane.error = error;
        }
      });
    },
    prevPane() {
      if (this.activePaneIndex > 0) {
        const prevIndex = this.activePaneIndex - 1;
        this.selectIndex(prevIndex);
      }
    },
    selectIndex(index) {
      if (index >= 0 && index < this.tabs.length) {
        this.select(this.tabs[index]);
      }
    },
    complete() {
      this.$emit("complete");
    }
  }
};
*/
